var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$templates() === 'themeTemplateOne')?_c('pc-layout-one'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }